module.exports = __webpack_public_path__ + "img/dice1p1.8191dda9.png";